import React from "react";
import { VulnerabilityTooltip } from "../../../../ui";
import { getCvssSeverity } from "../../../../utils";
import styles from "./vulnerabilityScore.module.scss";
const VulnerabilityScore = ({ cvss, exploit, className, }) => {
    const severity = getCvssSeverity(cvss.base_score);
    return (React.createElement(VulnerabilityTooltip, { cvss: cvss, exploit: exploit },
        React.createElement("span", { className: `${styles.badge} ${styles[`badge-${severity}`]} ${className !== null && className !== void 0 ? className : ""}` },
            React.createElement("b", null, cvss.base_score.toFixed(1)),
            React.createElement("b", null, severity))));
};
export default VulnerabilityScore;
//# sourceMappingURL=VulnerabilityScore.js.map